const map = {
	"./unlogo_white_ar.svg": 8962,
	"./unlogo_white_ch.svg": 614,
	"./unlogo_white_en.svg": 7538,
	"./unlogo_white_es.svg": 7255,
	"./unlogo_white_fr.svg": 7007,
	"./unlogo_white_ru.svg": 3156
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8801;